import greenTickAnimation from "../../assets/images/greenTickAnimation.svg";

const SuccessCelebrationIcon = ({ size = 200, className = "" }) => (
  <img
    src={greenTickAnimation}
    alt=""
    width={size}
    height={size}
    className={`shrink-0 ${className}`.trim()}
    aria-hidden
  />
);

export default SuccessCelebrationIcon;
